import signupListPublicView from "testUtils/mockData/signuplist/6/publicview";

import editFundItOptions from "./editFundItOptions";
import editItemFundItOptions from "./editItemFundItOptions";
import { editSignupListOption } from "./editSignupListOptions";

const mockResponses = {
  editFundItOptions,
  editItemFundItOptions,
  signupListPublicView,
  editSignupListOption,
};

export default mockResponses;